import _taggedTemplateLiteral from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
import { __rest as e } from "../_virtual/_tslib.js";
import { jsx as t } from "react/jsx-runtime";
import i from "react";
import r from "styled-components";
import { Grid as n } from "react-styled-flexboxgrid";
import { withVDSManager as o, calculateRem as l, breakpoints as a } from "@vds-core/utilities";
import { LayoutTokens as d } from "@vds-tokens/layout";
function s(e) {
  return Number(e.split("px", 1)) / 16;
}
var m = r.div.withConfig({
  displayName: "StyledGridContainer",
  componentId: "VDS__sc-182nyaf-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 100%;\n  max-width: ", ";\n  margin: 0 auto;\n  ", ";\n"])), function (_ref) {
  var e = _ref.bleed;
  return "full" === e ? "100%" : "1920" === e ? "1920px" : "1600" === e ? "1600px" : "1440" === e ? "1440px" : "1272px";
}, function (_ref2) {
  var e = _ref2.height;
  return e && "\n    height: ".concat(e, ";\n  ");
});
function p(e, t, i) {
  var r;
  r = i ? t : "mobileLarge" === t ? "mobile" : "tabletLarge" === t ? "tablet" : "desktopLarge" === t || "desktopXLarge" === t ? "desktop" : t;
  return {
    xs: t ? e[r] : e.mobile,
    sm: t ? e[r] : i ? e.mobileLarge : e.mobile,
    md: t ? e[r] : i ? e.tabletLarge : e.tablet,
    lg: t ? e[r] : i ? "undefined" != typeof window && window.innerWidth >= 1921 ? e.desktopXLarge : e.desktopLarge : e.desktop
  };
}
var g = o(function (r) {
  var o = r.children,
    _r$gutterWidth = r.gutterWidth,
    g = _r$gutterWidth === void 0 ? "40px" : _r$gutterWidth,
    c = r.rowGutter,
    u = r.viewport,
    _r$colSizes = r.colSizes,
    f = _r$colSizes === void 0 ? {
      mobile: 1,
      mobilelarge: 1,
      tablet: 1,
      tabletlarge: 1,
      desktop: 1,
      desktoplarge: 1,
      desktopxlarge: 1
    } : _r$colSizes,
    _r$bleed = r.bleed,
    b = _r$bleed === void 0 ? "1440" : _r$bleed,
    _r$expanded = r.expanded,
    h = _r$expanded === void 0 ? !1 : _r$expanded,
    _r$height = r.height,
    x = _r$height === void 0 ? "100%" : _r$height,
    y = e(r, ["children", "gutterWidth", "rowGutter", "viewport", "colSizes", "bleed", "expanded", "height"]),
    v = d.space["3X"].value,
    w = "10px",
    L = "undefined" != typeof window && window.innerWidth,
    k = "mobile" === u || "mobileLarge" === u || L && L < 768 ? v : "24px" === g ? 24 : 40,
    j = l(k),
    O = p(f, u, h),
    S = Object.assign(Object.assign({}, a), {
      lg: "1024"
    }),
    _W = function W(e) {
      return i.Children.toArray(e).flatMap(function (e) {
        return i.isValidElement(e) && e.type === i.Fragment ? _W(e.props.children) : e;
      });
    },
    z = {
      flexboxgrid: {
        gridSize: "mobile" === u || "mobileLarge" === u ? 4 : 12,
        gutterWidth: j.replace("rem", ""),
        mediaQuery: "only screen",
        breakpoints: {
          xs: s("0px"),
          sm: s(S.md),
          md: s(S.lg),
          lg: s(S.xl)
        }
      }
    },
    E = _W(o);
  return t(n, {
    theme: z,
    fluid: !0,
    style: {
      paddingRight: 0,
      paddingLeft: 0,
      marginRight: 0,
      marginLeft: 0,
      maxWidth: "100%",
      fontSize: "16px",
      flex: 1
    },
    children: t(m, Object.assign({}, y, {
      bleed: b,
      theme: z,
      $gutterWidth: k,
      children: null == E ? void 0 : E.map(function (e, t) {
        var r;
        var n = {
            flexDirection: "row",
            justifyContent: "flex-start",
            marginRight: "auto",
            marginLeft: "auto",
            paddingRight: "mobile" === u || "mobileLarge" === u ? w : 24 === k ? d.space["2X"].value : 0,
            paddingLeft: "mobile" === u || "mobileLarge" === u ? w : 24 === k ? d.space["2X"].value : 0
          },
          o = _W(null === (r = null == e ? void 0 : e.props) || void 0 === r ? void 0 : r.children).map(function (e, t) {
            if (i.isValidElement(e)) {
              var _r = function (e, t, i, r) {
                  var n = e.props.colSizes && p(e.props.colSizes, i, r) || {};
                  return Object.keys(n).forEach(function (e) {
                    return void 0 === n[e] && delete n[e];
                  }), 4 === Object.keys(n).length ? n : Object.assign(Object.assign({}, t), n);
                }(e, O, u, h),
                _n = {
                  marginBottom: c || 0
                };
              return i.cloneElement(e, Object.assign({
                key: t + 1,
                style: _n,
                theme: z
              }, _r));
            }
            return e;
          });
        return i.cloneElement(e, {
          key: t + 1,
          style: n,
          theme: z
        }, o);
      })
    }))
  });
}, !0);
export { g as default };